// function test () {
//   // var sql = concatSqlDay(nowDay(new Date()), 'A0101-1007', "0101", "8621")
//   // var sql = concatSqYear('T-A0101-1004', "0101", "8621")
//   var sql = date.bank.month.toString()
//
//   var test = sqlNotDay(sql, 'A0101-1007', '0101', '8621')
//   // console.log("--" + test);
// }
import {getSmartbiUrl} from '../request'
import store from '../../store'

// sql拼接
// isAssement:口径(0：标准口径；1：考核口径)
// isRealTimeIndex：是否实时指标（0：离线；1：实时）
// isDay, isMonth, isYear：日、月、年、
// date：时间、
// isRate：是否率值指标(0:否；1：是)、
// sql：原始sql
// channel:渠道id
// orgId：机构id
// indexCode：指标id
// isPie:是否饼图（产品分析、结构分析、银行渠道分析报表）
export function getChartSql (isAssement, isRealTimeIndex, isDay, isMonth, isYear, date, isRate, sql, channel, orgId, indexCode, isPie, isBatchFinish, isPreEntry, startTime) {
  sql = sql.replace(/\$V_UNIONSQL/g, getUnionSql(isYear, isMonth, isAssement))
  sql = sql.replace(/\$V_INDEX_CODE/g, "'" + indexCode + "'")
  sql = sql.replace(/\$V_MANAGECODE/g, "'" + orgId + "'")
    .replace(/\$V_SALES_CHANNEL/g, "'" + channel + "'")
  sql = sql.replace(/\$V_FLAGYEARLAST/g, "'" + getFlagYear(date, 'before') + "'")
  sql = sql.replace(/\$V_FLAGYEAR/g, "'" + getFlagYear(date, 'now') + "'")
  if (indexCode === 'A0104-1004') {
    sql = sql.replace(/\(\$V_DATEIDDX\)/g, '(' + getDaysDx(isDay, date, indexCode) + ')')
      .replace(/\(\$V_DATEIDDXBF\)/g, '(' + getDaysDxBefore(date, indexCode) + ')')
      .replace(/\$V_DXUNIONALL/g, getDxUnionAll(indexCode, date))
  } else if (isPie) {
    if (isRealTimeIndex) {
      sql = sql.replace(/\(\$V_RTDATEID\)/g, '(' + getPieRealRTData(date, isMonth, isYear, isBatchFinish, isPreEntry, startTime) + ')')
        .replace(/\(\$V_OTDATEID\)/g, '(' + getPieRealOTData(date, isMonth, isYear, isBatchFinish, isPreEntry, startTime) + ')')
        .replace(/\$V_TERM_PREM/g, getTermPrem(indexCode, isPie))
    } else { // 离线指标人力 + 率值
      sql = sql.replace(/= \$V_PIEDATEID/g, '=' + getPieNotRealDate(date, isRate, isBatchFinish))
    }
  } else {
    if (!isRealTimeIndex && isRate) { // 离线指标  人力 + 率值
      sql = sql.replace(/\(\$V_OTDATEID\)/g, '(' + getOTNotRealTrendDays(isDay, isRate, isBatchFinish, isMonth, isYear, isAssement) + ')')
    } else { // 实时指标
      if (isBatchFinish) { // 跑数成功
        sql = sql.replace(/\(\$V_RTDATEID\)/g, '(' + getRTRealTrendDays(isRealTimeIndex) + ')')
          .replace(/\(\$V_LASTOTDATEID\)/g, '(' + getOTRealTrendDays(isRealTimeIndex, isAssement, isDay, 'last', isPreEntry, startTime) + ')')
          .replace(/\(\$V_OTDATEID\)/g, '(' + getOTRealTrendDays(isRealTimeIndex, isAssement, isDay, 'now', isPreEntry, startTime) + ')')
      } else {
        sql = sql.replace(/\(\$V_RTDATEID\)/g, '(' + getRTRealTrendFlaseDays(isRealTimeIndex, isMonth, isDay, isPreEntry, startTime) + ')')
          .replace(/\(\$V_LASTOTDATEID\)/g, '(' + getOTRealTrendFalseDays(isRealTimeIndex, isAssement, isDay, isMonth, 'last', isYear, isPreEntry, startTime) + ')')
          .replace(/\(\$V_OTDATEID\)/g, '(' + getOTRealTrendFalseDays(isRealTimeIndex, isAssement, isDay, isMonth, 'now', isYear, isPreEntry, startTime) + ')')
          .replace(/\$V_BEDATEID/g, getDateNewBe())
          .replace(/\$V_NEWDATEID/g, getDateNew())
          .replace(/\$V_DATEIDLAST/g, getDateLast())
      }
    }
  }
  return '(' + sql + ' ) f'
}

// 标准指标拼接
export function getFlagYear (date, flage) {
  let flagYear = ''
  if (flage === 'now') {
    flagYear = date.getFullYear()
  } else {
    flagYear = date.getFullYear() - 1
  }
  return flagYear
}

// 标准指标拼接
export function getUnionSql (isYear, isMonth, isAssement) {
  let unionSQL = ''
  if (!isAssement && isMonth) {
    unionSQL = 'UNION ALL SELECT a.FINISH_TIME, a.MONTH_VALUE FROM OT_K_ADS_GENERAL_REPORT a WHERE a.MANAGE_CODE = $V_MANAGECODE AND A.SALES_CHANNEL = $V_SALES_CHANNEL AND A.FINISH_TIME IN ($V_LASTOTDATEID) AND A.INDEX_CODE = $V_INDEX_CODE AND A.Flag = $V_FLAGYEARLAST '
  } else if (!isAssement && isYear) {
    unionSQL = 'UNION ALL SELECT a.FINISH_TIME,a.MANAGE_CODE,A.SALES_CHANNEL,A.INDEX_CODE,a.YEAR_VALUE,A.YEAR_VALUE_LAST FROM OT_K_ADS_GENERAL_REPORT a WHERE ( \'?\' = \'?\'or 1 = 1 ) and a.MANAGE_CODE = $V_MANAGECODE AND A.SALES_CHANNEL = $V_SALES_CHANNEL AND A.FINISH_TIME IN ($V_LASTOTDATEID) AND A.INDEX_CODE = $V_INDEX_CODE AND A.Flag = $V_FLAGYEARLAST  '
  }
  return unionSQL
}

// 离线类指标的趋势图   OT表
export function getOTNotRealTrendDays (isDay, isRate, isBatchFinish, isMonth, isYear, isAssement) {
  var date = new Date()
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  let day = ''
  let yesterday = ''
  // 跑数成功
  if (isBatchFinish) {
    switch (true) {
      // 率值指标 日
      case Boolean(isDay):
        for (let i = 1; i < 31; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 率值指标的考核口径 月|年  显示当年年月
      case Boolean(isAssement && (isMonth || isYear)):
        yesterday = new Date(date.getTime() - cur)
        year = yesterday.getFullYear()
        month = yesterday.getMonth()
        day = yesterday.getDate()
        dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
        for (let i = month; i > 0; i--) {
          let monthFirstDay3 = new Date(year, i, 1)
          let monthFinishDay3 = new Date(monthFirstDay3.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay3.getFullYear()) + String(changeDay(monthFinishDay3.getMonth() + 1)) + String(changeDay(monthFinishDay3.getDate())) + "'")
        }
        break
      // 率值指标的标准口径 月|年  显示近12月
      default:
        yesterday = new Date(date.getTime() - cur)
        year = yesterday.getFullYear()
        month = yesterday.getMonth()
        day = yesterday.getDate()
        dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
        for (var j = 11; j > 0; j--) {
          let monthFirstDay4 = new Date(year, month, 1)
          let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
          year = monthFinishDay4.getFullYear()
          month = monthFinishDay4.getMonth()
          dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
        }
        break
    }
  } else {
    switch (true) {
      // 率值指标 日
      case Boolean(isDay):
        for (let i = 3; i < 33; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 率值指标的考核口径 月|年  显示当年年月
      case Boolean(isAssement && (isMonth || isYear)):
        var yesterdayTwo = new Date(date.getTime() - cur * 3)
        year = yesterdayTwo.getFullYear()
        month = yesterdayTwo.getMonth()
        dayArray.push("'" + String(yesterdayTwo.getFullYear()) + String(changeDay(yesterdayTwo.getMonth() + 1)) + String(changeDay(yesterdayTwo.getDate())) + "'")
        if (date.getDate() === 3) {
          dayArray.push("'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(1)) + "'")
        }
        for (var o = yesterdayTwo.getMonth(); o > 0; o--) {
          let monthFirstDayNotReal = new Date(year, month, 1)
          monthFirstDayNotReal = new Date(monthFirstDayNotReal.getTime() - cur)
          year = monthFirstDayNotReal.getFullYear()
          month = monthFirstDayNotReal.getMonth()
          dayArray.push("'" + String(monthFirstDayNotReal.getFullYear()) + String(changeDay(monthFirstDayNotReal.getMonth() + 1)) + String(changeDay(monthFirstDayNotReal.getDate())) + "'")
        }
        break
      // 率值指标的标准口径 月|年  显示近12月
      default:
        var yesterday3 = new Date(date.getTime() - cur * 3)
        year = yesterday3.getFullYear()
        month = yesterday3.getMonth()
        dayArray.push("'" + String(yesterday3.getFullYear()) + String(changeDay(yesterday3.getMonth() + 1)) + String(changeDay(yesterday3.getDate())) + "'")
        if (date.getDate() === 3) {
          dayArray.push("'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(1)) + "'")
          for (var q = 11; q > 1; q--) {
            let monthFirstDay4 = new Date(year, month, 1)
            let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
            year = monthFinishDay4.getFullYear()
            month = monthFinishDay4.getMonth()
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          }
        } else {
          for (var e = 11; e > 0; e--) {
            let monthFirstDay4 = new Date(year, month, 1)
            let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
            year = monthFinishDay4.getFullYear()
            month = monthFinishDay4.getMonth()
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          }
        }

        break
    }
  }
  return dayArray
}

// 实时类指标的趋势图   OT表
export function getOTRealTrendDays (isRealTimeIndex, isAssement, isDay, flag, isPreEntry, startTime) {
  var date = new Date()
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  let day = ''
  if (isPreEntry) {
    let iDays = parseInt(Math.abs(date.getTime() - startTime) / 1000 / 60 / 60 / 24)
    switch (true) {
      case Boolean(isDay):
        if (iDays > 29) {
          for (let i = 1; i < 30; i++) {
            let lastDay = new Date(date.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        } else if (iDays < 1) {
          dayArray.push("''")
        } else {
          iDays = iDays + 1
          for (let i = 1; i < iDays; i++) {
            let lastDay = new Date(date.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        }
        break
      default:
        var start = new Date(startTime)
        year = date.getFullYear()
        month = date.getMonth()
        day = date.getDate()
        if (iDays !== 0) {
          let startMonth = start.getMonth()
          dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
          for (var k = month; k > 0 && k > startMonth; k--) {
            let monthFirstDay2 = new Date(year, k, 1)
            let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
            dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
          }
        } else {
          dayArray.push("''")
        }
        break
    }
  } else {
    switch (true) {
      // 离线指标 日
      case Boolean(isDay && !isRealTimeIndex):
        for (let i = 1; i < 31; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 实时指标 日
      case Boolean(isDay && isRealTimeIndex):
        for (let i = 1; i < 30; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 离线指标的考核口径 月|年  显示当年年月
      case Boolean(isAssement && !isRealTimeIndex):
        let lastDay = new Date(date.getTime() - cur)
        year = lastDay.getFullYear()
        month = lastDay.getMonth()
        day = lastDay.getDate()
        dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
        for (var i = month; i > 0; i--) {
          let monthFirstDay2 = new Date(year, i, 1)
          let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
        }
        break
      // 离线指标的标准口径 月|年  显示近12月
      case Boolean(!isAssement && !isRealTimeIndex):
        let lastNotRealDay = new Date(date.getTime() - cur)
        year = lastNotRealDay.getFullYear()
        month = lastNotRealDay.getMonth()
        day = lastNotRealDay.getDate()
        if (flag === 'now') {
          dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
        }
        for (var j = 11; j > 0; j--) {
          let monthFirstDay4 = new Date(year, month, 1)
          let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
          year = monthFinishDay4.getFullYear()
          month = monthFinishDay4.getMonth()
          if (flag === 'now' && date.getFullYear() === monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          } else if (flag === 'last' && date.getFullYear() !== monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          }
        }
        break
      // 实时指标的考核口径 月|年  显示当年年月
      case Boolean(isAssement && isRealTimeIndex):
        year = date.getFullYear()
        month = date.getMonth()
        day = date.getDate()
        dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
        for (var l = month; l > 0; l--) {
          let monthFirstDay2 = new Date(year, l, 1)
          let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
        }
        break
      // 实时指标的标准口径 月|年  显示近12月
      default:
        year = date.getFullYear()
        month = date.getMonth()
        day = date.getDate()
        if (flag === 'now') {
          dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
        }
        for (var c = 11; c > 0; c--) {
          let monthFirstDay4 = new Date(year, month, 1)
          let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
          year = monthFinishDay4.getFullYear()
          month = monthFinishDay4.getMonth()
          if (flag === 'now' && date.getFullYear() === monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          } else if (flag === 'last' && date.getFullYear() !== monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          }
        }
        break
    }
  }
  return dayArray
}
// 实时类指标的趋势图   OT表
export function getOTRealTrendFalseDays (isRealTimeIndex, isAssement, isDay, isMonth, flag, isYear, isPreEntry, startTime) {
  var date = new Date()
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  let day = ''
  if (isPreEntry) {
    let iDays = parseInt(Math.abs(date.getTime() - startTime) / 1000 / 60 / 60 / 24)
    switch (true) {
      case Boolean(isDay):
        if (iDays > 29) {
          for (let i = 2; i < 30; i++) {
            let lastDay = new Date(date.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        } else if (iDays < 2) {
          dayArray.push("''")
        } else {
          iDays = iDays + 1
          for (let i = 2; i < iDays; i++) {
            let lastDay = new Date(date.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        }
        break
      default:
        var start = new Date(startTime)
        let yesterday1 = new Date(date.getTime() - cur * 2)
        year = yesterday1.getFullYear()
        month = yesterday1.getMonth()
        day = yesterday1.getDate()
        if (flag === 'now') {
          if ((date.getDate() === 1 && isMonth) || iDays < 2) {
            dayArray.push("''")
          } else if (isYear && date.getDate() === 2 && iDays > 1) {
            dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
            dayArray.push("'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(1)) + "'")
          } else {
            dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
          }
        }
        if (iDays > 2) {
          let startMonth = start.getMonth()
          for (var k = month; k > 0 && k > startMonth; k--) {
            let monthFirstDay2 = new Date(year, k, 1)
            let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
            dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
          }
        }
        break
    }
  } else {
    switch (true) {
      // 实时指标 日
      case Boolean(isDay && isRealTimeIndex):
        for (let i = 2; i < 32; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 离线指标 日
      case Boolean(isDay && !isRealTimeIndex):
        for (let i = 2; i < 30; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 离线指标的考核口径 月|年  显示当年年月
      case Boolean(isAssement && (isMonth || isYear) && !isRealTimeIndex):
        let yesterday = new Date(date.getTime() - cur * 2)
        year = yesterday.getFullYear()
        month = yesterday.getMonth()
        day = yesterday.getDate()
        dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
        for (var i = month; i > 0; i--) {
          let monthFirstDay2 = new Date(year, i, 1)
          let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
        }
        break
      // 离线指标的标准口径 月|年  显示12 个年月
      case Boolean(!isAssement && (isMonth || isYear) && !isRealTimeIndex):
        let yesterdays = new Date(date.getTime() - cur * 2)
        year = yesterdays.getFullYear()
        month = yesterdays.getMonth()
        day = yesterdays.getDate()
        if (flag === 'now') {
          dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
        }
        for (var j = 11; j > 0; j--) {
          let monthFirstDay4 = new Date(year, month, 1)
          let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
          year = monthFinishDay4.getFullYear()
          month = monthFinishDay4.getMonth()
          if (flag === 'now' && date.getFullYear() === monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          } else if (flag === 'last' && date.getFullYear() !== monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          }
        }
        break
      // 实时指标的考核口径 月| 年  显示当年年月
      case Boolean(isAssement && (isMonth || isYear) && isRealTimeIndex):
        let yesterday1 = new Date(date.getTime() - cur * 2)
        year = yesterday1.getFullYear()
        month = yesterday1.getMonth()
        day = yesterday1.getDate()
        if (flag === 'now') {
          if (date.getDate() === 1 && isMonth) {
            dayArray.push("''")
          } else if (isYear && date.getDate() === 2) {
            dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
            dayArray.push("'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(1)) + "'")
          } else {
            dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
          }
        }
        for (var s = month; s > 0; s--) {
          let monthFirstDay2 = new Date(year, s, 1)
          let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
        }
        break
      // 实时指标的标准口径 月|年  显示12个年月
      default:
        let yesterday2 = new Date(date.getTime() - cur * 2)
        year = yesterday2.getFullYear()
        month = yesterday2.getMonth()
        day = yesterday2.getDate()
        if (flag === 'now') {
          if (date.getDate() === 1 && isMonth) {
            dayArray.push("''")
          } else if (isYear && date.getDate() === 2) {
            dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
            dayArray.push("'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(1)) + "'")
          } else {
            dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
          }
        }
        for (var h = 11; h > 0; h--) {
          let monthFirstDay4 = new Date(year, month, 1)
          let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
          year = monthFinishDay4.getFullYear()
          month = monthFinishDay4.getMonth()
          if (flag === 'now' && date.getFullYear() === monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          } else if (flag === 'last' && date.getFullYear() !== monthFinishDay4.getFullYear()) {
            dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
          }
        }
        break
    }
  }
  return dayArray
}

export function getPieRealRTData (date, isMonth, isYear, isBatchFinish, isPreEntry, startTime) {
  // 实时数据是否已经跑完，实时指标昨天往前推，离线指标前天往前推
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  var today = new Date()
  let yesterday = ''
  if (isBatchFinish) {
    // 只要是 年月一致
    if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
      //  跑数成功 所有日期查询今天
      dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
    } else {
      // 非本月查询的离线数据 饼状图RT都是null
      dayArray = "''"
    }
  } else {
    if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
      if (isPreEntry) {
        let iDays = parseInt(Math.abs(date.getTime() - startTime) / 1000 / 60 / 60 / 24)
        // 除了日历月并且月初外其他日期  并跑数失败 RT 查询今天和昨天
        if ((date.getDate() === 1 && isMonth) || (isYear && date.getDate() === 1 && date.getMonth() === 0) || (isPreEntry && iDays === 0)) {
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
        } else {
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
          yesterday = new Date(today.getTime() - cur)
          dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
        }
      } else {
        // 除了日历月并且月初外其他日期  并跑数失败 RT 查询今天和昨天
        if ((date.getDate() === 1 && isMonth) || (isYear && date.getDate() === 1 && date.getMonth() === 0)) {
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
        } else {
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
          yesterday = new Date(today.getTime() - cur)
          dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
        }
      }
    } else {
      // 非本月查询的离线数据 饼状图RT都是null
      dayArray = "''"
    }
  }
  return dayArray
}
export function getPieRealOTData (date, isMonth, isYear, isBatchFinish, isPreEntry, startTime) {
  // 实时数据是否已经跑完，实时指标昨天往前推，离线指标前天往前推
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  var today = new Date()
  let yesterday = ''
  if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
    if (isBatchFinish) {
      dayArray.push("'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(date.getDate())) + "'")
    } else {
      if (((date.getDate() === 1 || date.getDate() === 2) && isMonth) || (isYear && (date.getDate() === 1 || date.getDate() === 2) && date.getMonth() === 0)) {
        dayArray.push("''")
      } else {
        if (isPreEntry) {
          let iDays = parseInt(Math.abs(date.getTime() - startTime) / 1000 / 60 / 60 / 24)
          if (iDays > 1) {
            yesterday = new Date(today.getTime() - cur * 2)
            dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
          } else {
            dayArray.push("''")
          }
        } else {
          yesterday = new Date(today.getTime() - cur * 2)
          dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
        }
      }
    }
  } else {
    // 不为当月时，时间为选取月的月底
    let year = date.getFullYear()
    let month = date.getMonth()
    if (month + 1 > 11) {
      year += 1
      month = 0
    } else {
      month = month + 1
    }
    // 选取的月的下个月的第一天
    let currentMonthFirstDay = new Date(year, month, 1)
    let finishDay = new Date(currentMonthFirstDay.getTime() - cur)
    dayArray.push("'" + String(finishDay.getFullYear()) + String(changeDay(finishDay.getMonth() + 1)) + String(changeDay(finishDay.getDate())) + "'")
  }
  return dayArray
}

// 率值人力类指标饼图。
export function getPieNotRealDate (date, isRate, isBatchFinish) {
  var result = ''
  var cur = 24 * 60 * 60 * 1000
  var today = new Date()
  // 饼图 率值类 人力类 离线类指标 跑数失败查询前天
  if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
    // 跑数失败 离线类指标
    if (!isBatchFinish) {
      if (isRate) {
        // 成功昨天
        let yesterday2 = new Date(today.getTime() - cur * 3)
        result = "'" + String(yesterday2.getFullYear()) + String(changeDay(yesterday2.getMonth() + 1)) + String(changeDay(yesterday2.getDate())) + "'"
      } else {
        // 前天
        let yesterday1 = new Date(today.getTime() - cur * 2)
        result = "'" + String(yesterday1.getFullYear()) + String(changeDay(yesterday1.getMonth() + 1)) + String(changeDay(yesterday1.getDate())) + "'"
      }
    } else {
      let yesterday2 = new Date(today.getTime() - cur)
      result = "'" + String(yesterday2.getFullYear()) + String(changeDay(yesterday2.getMonth() + 1)) + String(changeDay(yesterday2.getDate())) + "'"
    }
  } else {
    // 不为当月时，时间为选取月的月底
    let year = date.getFullYear()
    let month = date.getMonth()
    if (month + 1 > 11) {
      year += 1
      month = 0
    } else {
      month = month + 1
    }
    // 选取的月的下个月的第一天
    let currentMonthFirstDay = new Date(year, month, 1)
    let finishDay = new Date(currentMonthFirstDay.getTime() - cur)
    result = "'" + String(finishDay.getFullYear()) + String(changeDay(finishDay.getMonth() + 1)) + String(changeDay(finishDay.getDate())) + "'"
  }
  return result
}

// 饼图（结构分析-首年期交保费T-A0102-1001）
export function getTermPrem (indexCode, isPie) {
  var result = ''
  if (isPie && indexCode === 'T-A0102-1001') {
    result = " AND  K.payyear_code != 'C1' "
  }
  return result
}

export function getRTRealTrendDays (isRealTimeIndex) {
  var today = new Date()
  let dayArray = []
  if (!isRealTimeIndex) {
    dayArray.push("''")
  } else {
    dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
  }
  return dayArray
}
export function getRTRealTrendFlaseDays (isRealTimeIndex, isMonth, isDay, isPreEntry, startTime) {
  var today = new Date()
  let dayArray = []
  var cur = 24 * 60 * 60 * 1000
  // 预录入指标
  if (isPreEntry) {
    let iDays = parseInt(Math.abs(today.getTime() - startTime) / 1000 / 60 / 60 / 24)
    if ((today.getDate() === 1 && isMonth) || isDay || iDays === 0) {
      dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
    } else {
      dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
      let finishDay = new Date(today.getTime() - cur)
      dayArray.push("'" + String(finishDay.getFullYear()) + String(changeDay(finishDay.getMonth() + 1)) + String(changeDay(finishDay.getDate())) + "'")
    }
  } else if (!isRealTimeIndex) {
    dayArray.push("''")
  } else if ((today.getDate() === 1 && isMonth) || isDay) {
    dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
  } else {
    dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
    let finishDay = new Date(today.getTime() - cur)
    dayArray.push("'" + String(finishDay.getFullYear()) + String(changeDay(finishDay.getMonth() + 1)) + String(changeDay(finishDay.getDate())) + "'")
  }
  return dayArray
}

// 考核指标、实时指标、日、月、年、日期、率值、饼图
export function getDate (isRealTimeIndex, isDay, isMonth, isYear, date, isRate, isPie, indexId) {
  var cur = 24 * 60 * 60 * 1000
  let year = date.getFullYear()
  let month = date.getMonth()
  let result = ''
  // 短险综合成本率时返回当前年月
  if (indexId === 'A0104-1004') {
    result = "'" + year.toString() + changeDay(month + 1).toString() + "'"
  } else {
    // 实时：实时指标：今天 离线指标：昨天
    // 离线：当前月：实时指标：今天，离线指标：昨天
    // 离线：之前月选择月的月底
    // 饼图的时间
    if (isPie) {
      let isBatchFinish = store.state.smartbi.isBatchFinish
      let today = new Date()
      // 为当月时
      if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
        switch (true) {
          // 当实时数据没有跑完时,离线和实时指标都取昨天的时间
          case Boolean(!isBatchFinish):
            let yesterday1 = new Date(today.getTime() - cur)
            result = "'" + String(yesterday1.getFullYear()) + String(changeDay(yesterday1.getMonth() + 1)) + String(changeDay(yesterday1.getDate())) + "'"
            break
          // 实时指标
          case Boolean(isRealTimeIndex):
            result = "'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'"
            break
          // 离线指标
          case Boolean(!isRealTimeIndex):
            let yesterday = new Date(today.getTime() - cur)
            result = "'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'"
            break
          default:
            result = "'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'"
            break
        }
      } else {
        // 不为当月时，时间为选取月的月底
        let year = date.getFullYear()
        let month = date.getMonth()
        if (month + 1 > 11) {
          year += 1
          month = 0
        } else {
          month = month + 1
        }
        // 选取的月的下个月的第一天
        let currentMonthFirstDay = new Date(year, month, 1)
        let finishDay = new Date(currentMonthFirstDay.getTime() - cur)
        result = "'" + String(finishDay.getFullYear()) + String(changeDay(finishDay.getMonth() + 1)) + String(changeDay(finishDay.getDate())) + "'"
      }
    } else {
      let isBatchFinish = store.state.smartbi.isBatchFinish
      if (!isBatchFinish) {
        // date = new Date(date.getTime() - cur)
      }
      switch (true) {
        // 离线非率值或者率值指标，昨天
        case Boolean((!isRealTimeIndex)):
          let yesterday = new Date(date.getTime() - cur)
          result = "'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'"
          break
        // 实时指标,今天
        case Boolean(isRealTimeIndex):
          result = "'" + String(date.getFullYear()) + String(changeDay(date.getMonth() + 1)) + String(changeDay(date.getDate())) + "'"
          break
      }
    }
  }
  return result
}

// 考核口径、标准口径，实时、离线指标，日月年
// 是否考核口径，是否实时指标，是否日、是否月、是否年、时间、是否率值指标、指标id
export function getDays (isAssement, isRealTimeIndex, isDay, isMonth, isYear, date, isRate, indexId) {
  // 实时数据是否已经跑完，实时指标昨天往前推，离线指标前天往前推
  let isBatchFinish = store.state.smartbi.isBatchFinish
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  let day = ''
  let yesterday = ''
  // 短险综合成本率：包括当前月在内的12个月的年月（格式：eg:201908）的值
  if (indexId === 'A0104-1004') {
    year = date.getFullYear()
    month = date.getMonth()
    dayArray.push("'" + String(year) + String(changeDay(month + 1)) + "'")
    for (var m = 0; m < 11; m++) {
      let monthFirstDay1 = new Date(year, month, 1)
      let monthFinishDay1 = new Date(monthFirstDay1.getTime() - cur)
      year = monthFinishDay1.getFullYear()
      month = monthFinishDay1.getMonth()
      dayArray.push("'" + String(monthFinishDay1.getFullYear()) + String(changeDay(monthFinishDay1.getMonth() + 1)) + "'")
    }
  } else {
    // 若实时数据还没有跑完，所有时间数据往前推一天,今天的改为昨天、昨天的改为前天
    if (!isBatchFinish) {
      date = new Date(date.getTime() - cur)
    }
    switch (true) {
      // 日：实时指标日：包括今天的近30天
      case Boolean(isDay && isRealTimeIndex):
        for (let i = 0; i < 30; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 日：离线指标日：包括昨天的近30天
      case Boolean(isDay && (!isRealTimeIndex)):
        for (let i = 1; i < 31; i++) {
          let lastDay = new Date(date.getTime() - cur * i)
          let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
          dayArray.push("'" + result + "'")
        }
        break
      // 月：考核口径、实时指标、非率值：今天加前每个月月底(今年的一月开始)
      case Boolean((isMonth || isYear) && isAssement && isRealTimeIndex && (!isRate)):
        year = date.getFullYear()
        month = date.getMonth()
        day = date.getDate()
        dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
        for (var i = month; i > 0; i--) {
          let monthFirstDay2 = new Date(year, i, 1)
          let monthFinishDay2 = new Date(monthFirstDay2.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay2.getFullYear()) + String(changeDay(monthFinishDay2.getMonth() + 1)) + String(changeDay(monthFinishDay2.getDate())) + "'")
        }
        break
      // 月：考核口径、离线指标、非率值：昨天加上每个月月底(今年的一月开始，若跨年，昨天的一年)
      case Boolean((isMonth || isYear) && isAssement && (!isRealTimeIndex) && (!isRate)):
        yesterday = new Date(date.getTime() - cur)
        year = yesterday.getFullYear()
        month = yesterday.getMonth()
        day = yesterday.getDate()
        dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
        for (let i = month; i > 0; i--) {
          let monthFirstDay3 = new Date(year, i, 1)
          let monthFinishDay3 = new Date(monthFirstDay3.getTime() - cur)
          dayArray.push("'" + String(monthFinishDay3.getFullYear()) + String(changeDay(monthFinishDay3.getMonth() + 1)) + String(changeDay(monthFinishDay3.getDate())) + "'")
        }
        break
      // 月：标准口径、实时指标、非率值：今天加上之前的近12个月(包括今天的12个月)
      case Boolean((isMonth || isYear) && (!isAssement) && isRealTimeIndex && (!isRate)):
        year = date.getFullYear()
        month = date.getMonth()
        day = date.getDate()
        dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
        for (var j = 11; j > 0; j--) {
          let monthFirstDay4 = new Date(year, month, 1)
          let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
          year = monthFinishDay4.getFullYear()
          month = monthFinishDay4.getMonth()
          dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
        }
        break
      // 月：标准口径、离线指标、非率值：昨天加上之前的近12个月(包括昨天)
      case Boolean((isMonth || isYear) && (!isAssement) && (!isRealTimeIndex) && (!isRate)):
        yesterday = new Date(date.getTime() - cur)
        year = yesterday.getFullYear()
        month = yesterday.getMonth()
        day = yesterday.getDate()
        dayArray.push("'" + String(year) + String(changeDay(month + 1)) + String(changeDay(day)) + "'")
        for (var k = 12; k > 0; k--) {
          let monthFirstDay5 = new Date(year, month, 1)
          let monthFinishDay5 = new Date(monthFirstDay5.getTime() - cur)
          year = monthFinishDay5.getFullYear()
          month = monthFinishDay5.getMonth()
          dayArray.push("'" + String(monthFinishDay5.getFullYear()) + String(changeDay(monthFinishDay5.getMonth() + 1)) + String(changeDay(monthFinishDay5.getDate())) + "'")
        }
        break
      // 离线加率值：昨天加上昨天所在的年的1月到昨天的每个月的月底
      case Boolean((isMonth || isYear) && (!isRealTimeIndex) && (isRate)):
        year = date.getFullYear()
        month = date.getMonth()
        var yesterday1 = new Date(date.getTime() - cur)
        year = yesterday1.getFullYear()
        month = yesterday1.getMonth()
        dayArray.push("'" + String(yesterday1.getFullYear()) + String(changeDay(yesterday1.getMonth() + 1)) + String(changeDay(yesterday1.getDate())) + "'")
        for (var o = yesterday1.getMonth(); o > 0; o--) {
          let monthFirstDay7 = new Date(year, month, 1)
          let monthFinishDay7 = new Date(monthFirstDay7.getTime() - cur)
          year = monthFinishDay7.getFullYear()
          month = monthFinishDay7.getMonth()
          dayArray.push("'" + String(monthFinishDay7.getFullYear()) + String(changeDay(monthFinishDay7.getMonth() + 1)) + String(changeDay(monthFinishDay7.getDate())) + "'")
        }
        break
      default:
        dayArray = []
        break
    }
  }
  return dayArray
}

// 获取RT查询日期  非率值类
export function getRTDays (date, isPie, isDay, isYear, isRealTimeIndex) {
  let isBatchFinish = store.state.smartbi.isBatchFinish
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let day = ''
  let yesterday = ''
  let today = new Date()
  // 非率值非人力类指标的饼图
  if (isPie) {
    day = today.getDate()
    // 只要是 年月一致
    if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
      // 除了月初外其他日期  并跑数失败 RT 查询今天和昨天
      if (day !== 1 && !isBatchFinish) {
        dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
        yesterday = new Date(today.getTime() - cur)
        dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
      } else {
        // 跑出失败月初RT查询今天  跑数成功 所有日期查询今天
        dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
      }
    } else {
      // 非本月查询的离线数据 饼状图RT都是null
      dayArray = "''"
    }
  } else {
    // T+1 指标没有RT表
    if (!isRealTimeIndex) {
      dayArray.push('null')
    } else {
      day = today.getDate()
      // 趋势图
      // 若实时数据还没有跑完
      if (!isBatchFinish) {
        if (isYear && today.getMonth() === 0 && today.getDate() === 1) {
          // 年初1号 RT 查询都是今天
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
        } else if ((day === 1 && !isYear) || isDay) {
          // 月初1号 RT 查询都是今天
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
        } else {
          // 其他  实时数据未跑完都是RT 查询昨天和今天
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
          yesterday = new Date(today.getTime() - cur)
          dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
        }
      } else {
        // 跑数成功 RT 查询都是今天
        dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
      }
    }
  }
  return dayArray
}
// 获取OT 查询日期  非率值类
export function getOTDays (isAssement, isDay, isMonth, isYear, date, isRate, isPie, isRealTimeIndex) {
  let isBatchFinish = store.state.smartbi.isBatchFinish
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  let day = ''
  let yesterday = ''
  let today = new Date()
  // 饼图
  if (isPie) {
    day = today.getDate()
    // 本月 OT 查询今天
    if ((date.getFullYear() === today.getFullYear()) && (date.getMonth() === today.getMonth())) {
      // 人力类 离线指标
      if (!isRealTimeIndex) {
        // 跑数失败
        if (!isBatchFinish) {
          yesterday = new Date(date.getTime() - cur * 2)
          dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
        } else {
          yesterday = new Date(date.getTime() - cur)
          dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
        }
      } else {
        // 跑数失败
        if (!isBatchFinish) {
          // 月初1号2号
          if (day === 1 || day === 2) {
            dayArray.push('null')
          } else {
            // 其他都是今昨天
            yesterday = new Date(date.getTime() - cur)
            dayArray.push("'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'")
          }
        } else {
          // 跑数成功 OT 查询都是今天
          dayArray.push("'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
        }
      }
    } else {
      // 不为当月时，时间为选取月的月底
      let year = date.getFullYear()
      let month = date.getMonth()
      if (month + 1 > 11) {
        year += 1
        month = 0
      } else {
        month = month + 1
      }
      // 选取的月的下个月的第一天
      let currentMonthFirstDay = new Date(year, month, 1)
      // 当前日期的月底
      let finishDay = new Date(currentMonthFirstDay.getTime() - cur)
      dayArray.push("'" + String(finishDay.getFullYear()) + String(changeDay(finishDay.getMonth() + 1)) + String(changeDay(finishDay.getDate())) + "'")
    }
  } else {
    // T+1指标 日：昨天30天 月、年：昨天当年月初到现在
    if (!isRealTimeIndex) {
      if (isDay) {
        if (!isBatchFinish) {
          // 失败 前天开始向前
          for (let i = 2; i < 32; i++) {
            let lastDay = new Date(date.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        } else {
          for (let i = 1; i < 31; i++) {
            let lastDay = new Date(date.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        }
      } else {
        if (!isBatchFinish) {
          var yesterdayTwo = new Date(date.getTime() - cur * 2)
          year = yesterdayTwo.getFullYear()
          month = yesterdayTwo.getMonth()
          dayArray.push("'" + String(yesterdayTwo.getFullYear()) + String(changeDay(yesterdayTwo.getMonth() + 1)) + String(changeDay(yesterdayTwo.getDate())) + "'")
          for (var o = yesterdayTwo.getMonth(); o > 0; o--) {
            let monthFirstDayNotReal = new Date(year, month, 1)
            monthFirstDayNotReal = new Date(monthFirstDayNotReal.getTime() - cur)
            year = monthFirstDayNotReal.getFullYear()
            month = monthFirstDayNotReal.getMonth()
            dayArray.push("'" + String(monthFirstDayNotReal.getFullYear()) + String(changeDay(monthFirstDayNotReal.getMonth() + 1)) + String(changeDay(monthFirstDayNotReal.getDate())) + "'")
          }
        } else {
          var yesterdayNot = new Date(date.getTime() - cur)
          year = yesterdayNot.getFullYear()
          month = yesterdayNot.getMonth()
          dayArray.push("'" + String(yesterdayNot.getFullYear()) + String(changeDay(yesterdayNot.getMonth() + 1)) + String(changeDay(yesterdayNot.getDate())) + "'")
          for (var k = yesterdayNot.getMonth(); k > 0; k--) {
            let monthFirstDayNotReal = new Date(year, month, 1)
            monthFirstDayNotReal = new Date(monthFirstDayNotReal.getTime() - cur)
            year = monthFirstDayNotReal.getFullYear()
            month = monthFirstDayNotReal.getMonth()
            dayArray.push("'" + String(monthFirstDayNotReal.getFullYear()) + String(changeDay(monthFirstDayNotReal.getMonth() + 1)) + String(changeDay(monthFirstDayNotReal.getDate())) + "'")
          }
        }
      }
    } else { // 实时指标
      // 若实时数据还没有跑完
      if (!isBatchFinish) {
        day = today.getDate()
        if (isDay) {
          // 日期 ot: 今天的之前的29天（去掉昨天 =28 个日期）
          for (let i = 2; i < 30; i++) {
            let lastDay = new Date(today.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        } else {
          month = today.getMonth()
          year = today.getFullYear()
          // 月 1号 隐藏上个月不显示  10个月
          if (day === 1) {
            if (isMonth) {
              // 标准口径显示12个月  OT 查询11个月 去掉上上个月
              if (!isAssement) {
                month = month - 1
                for (var j = 10; j > 0; j--) {
                  let monthFirstDayNo = new Date(year, month, 1)
                  monthFirstDayNo = new Date(monthFirstDayNo.getTime() - cur)
                  year = monthFirstDayNo.getFullYear()
                  month = monthFirstDayNo.getMonth()
                  dayArray.push("'" + String(monthFirstDayNo.getFullYear()) + String(changeDay(monthFirstDayNo.getMonth() + 1)) + String(changeDay(monthFirstDayNo.getDate())) + "'")
                }
              } else {
                // 考核口径
                // 年初到上上个月所有月底之
                if (today.getMonth() === 0 || today.getMonth() === 1) {
                  dayArray.push('null')
                } else {
                  for (var i = month; i > 1; i--) {
                    let monthFirstDayKo = new Date(year, i - 1, 1)
                    monthFirstDayKo = new Date(monthFirstDayKo.getTime() - cur)
                    dayArray.push("'" + String(monthFirstDayKo.getFullYear()) + String(changeDay(monthFirstDayKo.getMonth() + 1)) + String(changeDay(monthFirstDayKo.getDate())) + "'")
                  }
                }
              }
            } else {
              // 标准口径显示12个月  OT 查询11个月
              if (!isAssement) {
                if (today.getMonth() === 0) {
                  month = month - 1
                  for (var a = 10; a > 0; a--) {
                    let monthFirstDayNo = new Date(year, month, 1)
                    monthFirstDayNo = new Date(monthFirstDayNo.getTime() - cur)
                    year = monthFirstDayNo.getFullYear()
                    month = monthFirstDayNo.getMonth()
                    dayArray.push("'" + String(monthFirstDayNo.getFullYear()) + String(changeDay(monthFirstDayNo.getMonth() + 1)) + String(changeDay(monthFirstDayNo.getDate())) + "'")
                  }
                } else {
                  for (var g = 11; g > 0; g--) {
                    let monthFirstDayNo = new Date(year, month, 1)
                    monthFirstDayNo = new Date(monthFirstDayNo.getTime() - cur)
                    year = monthFirstDayNo.getFullYear()
                    month = monthFirstDayNo.getMonth()
                    dayArray.push("'" + String(monthFirstDayNo.getFullYear()) + String(changeDay(monthFirstDayNo.getMonth() + 1)) + String(changeDay(monthFirstDayNo.getDate())) + "'")
                  }
                }
              } else {
                // 考核口径
                // 年初到 11个月
                if (today.getMonth() === 0) {
                  dayArray.push('null')
                } else {
                  for (var x = month; x > 0; x--) {
                    let monthFirstDayKo = new Date(year, x, 1)
                    monthFirstDayKo = new Date(monthFirstDayKo.getTime() - cur)
                    dayArray.push("'" + String(monthFirstDayKo.getFullYear()) + String(changeDay(monthFirstDayKo.getMonth() + 1)) + String(changeDay(monthFirstDayKo.getDate())) + "'")
                  }
                }
              }
            }
          } else {
            dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day - 1).toString() + "'")
            yesterday = new Date(date.getTime() - cur)
            // 标准口径显示12个月  OT 查询 昨天 + 前11个月
            if (!isAssement) {
              for (var ss = 11; ss > 0; ss--) {
                let monthFirstDayNo = new Date(year, month, 1)
                monthFirstDayNo = new Date(monthFirstDayNo.getTime() - cur)
                year = monthFirstDayNo.getFullYear()
                month = monthFirstDayNo.getMonth()
                dayArray.push("'" + String(monthFirstDayNo.getFullYear()) + String(changeDay(monthFirstDayNo.getMonth() + 1)) + String(changeDay(monthFirstDayNo.getDate())) + "'")
              }
            } else {
              // 考核口径
              for (var s = yesterday.getMonth(); s > 0; s--) {
                let monthFirstDays = new Date(year, month, 1)
                monthFirstDays = new Date(monthFirstDays.getTime() - cur)
                year = monthFirstDays.getFullYear()
                month = monthFirstDays.getMonth()
                dayArray.push("'" + String(monthFirstDays.getFullYear()) + String(changeDay(monthFirstDays.getMonth() + 1)) + String(changeDay(monthFirstDays.getDate())) + "'")
              }
            }
          }
        }
      } else {
        if (isDay) {
          // 日期 ot: 今天的之前的29天
          for (let i = 1; i < 30; i++) {
            let lastDay = new Date(today.getTime() - cur * i)
            let result = String(lastDay.getFullYear()) + String(changeDay(lastDay.getMonth() + 1)) + String(changeDay(lastDay.getDate()))
            dayArray.push("'" + result + "'")
          }
        } else {
          if (!isAssement) {
            // 标准口径 跑数成功查询的都是今天 加年初到上个月所有月底
            year = date.getFullYear()
            month = date.getMonth()
            day = date.getDate()
            dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
            for (var p = 11; p > 0; p--) {
              let monthFirstDay4 = new Date(year, month, 1)
              let monthFinishDay4 = new Date(monthFirstDay4.getTime() - cur)
              year = monthFinishDay4.getFullYear()
              month = monthFinishDay4.getMonth()
              dayArray.push("'" + String(monthFinishDay4.getFullYear()) + String(changeDay(monthFinishDay4.getMonth() + 1)) + String(changeDay(monthFinishDay4.getDate())) + "'")
            }
          } else {
            // 跑数成功查询的都是今天 加年初到上个月所有月底
            year = today.getFullYear()
            month = today.getMonth()
            day = today.getDate()
            dayArray.push("'" + year.toString() + changeDay(month + 1).toString() + changeDay(day).toString() + "'")
            for (var d = month; d > 0; d--) {
              let monthFirstDaySu = new Date(year, d, 1)
              monthFirstDaySu = new Date(monthFirstDaySu.getTime() - cur)
              dayArray.push("'" + String(monthFirstDaySu.getFullYear()) + String(changeDay(monthFirstDaySu.getMonth() + 1)) + String(changeDay(monthFirstDaySu.getDate())) + "'")
            }
          }
        }
      }
    }
  }
  return dayArray
}

export function getDateNew () {
  let result = ''
  let today = new Date()
  result = "'" + String(today.getFullYear()) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'"
  return result
}

export function getDateNewBe () {
  let cur = 24 * 60 * 60 * 1000
  let result = ''
  let today = new Date()
  // if (today.getDate() === 1 || today.getDate() === 2) {
  //   result = 'NULL'
  // } else {
  if (today.getDate() === 2) {
    let yesterday = new Date(today.getTime() - cur * 1)
    result = "'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'"
  } else {
    let yesterday = new Date(today.getTime() - cur * 2)
    result = "'" + String(yesterday.getFullYear()) + String(changeDay(yesterday.getMonth() + 1)) + String(changeDay(yesterday.getDate())) + "'"
  }
  // }
  return result
}

export function getDateLast () {
  let dayArray = []
  let today = new Date()
  dayArray.push("'" + String(today.getFullYear() - 1) + String(changeDay(today.getMonth() + 1)) + String(changeDay(today.getDate())) + "'")
  return dayArray
}

// 短险综合成本率  2019 不包含当前月的1月到上个月   2019年后显示不包含当前月的前12个月
export function getDaysDx (isDay, date, indexId) {
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  // 短险综合成本率：不包括当前月在内的12个月的年月（格式：eg:201908）的值
  if (indexId === 'A0104-1004') {
    year = date.getFullYear()
    if (year === 2019) {
      month = date.getMonth()
      for (var s = 0; s < month; s++) {
        dayArray.push("'" + String(year) + String(changeDay(s + 1)) + "'")
      }
    } else {
      month = date.getMonth()
      for (var p = 0; p < 12; p++) {
        let monthFirstDay1 = new Date(year, month, 1)
        let monthFinishDay1 = new Date(monthFirstDay1.getTime() - cur)
        year = monthFinishDay1.getFullYear()
        month = monthFinishDay1.getMonth()

        dayArray.push("'" + String(monthFinishDay1.getFullYear()) + String(changeDay(monthFinishDay1.getMonth() + 1)) + "'")
      }
    }
  }
  return dayArray
}

// 短险综合成本率 对比年月   （2019 不包含当前月的1月到上个月   2019年后显示不包含当前月的前12个月）相应前一年的对比年月
export function getDaysDxBefore (date, indexId) {
  let dayArray = []
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  // 短险综合成本率：不包括当前月在内的12个月的年月（格式：eg:201908）的值
  if (indexId === 'A0104-1004') {
    year = date.getFullYear() - 1
    if (year === 2018) {
      month = date.getMonth()
      for (var f = 0; f < month; f++) {
        dayArray.push("'" + String(year) + String(changeDay(f + 1)) + "'")
      }
    } else {
      month = date.getMonth()
      for (var t = 0; t < 12; t++) {
        let monthFirstDay1 = new Date(year, month, 1)
        let monthFinishDay1 = new Date(monthFirstDay1.getTime() - cur)
        year = monthFinishDay1.getFullYear()
        month = monthFinishDay1.getMonth()
        dayArray.push("'" + String(monthFinishDay1.getFullYear()) + String(changeDay(monthFinishDay1.getMonth() + 1)) + "'")
      }
    }
  }
  return dayArray
}

// 短险综合成本率 对比年月   （2019 不包含当前月的1月到上个月   2019年后显示不包含当前月的前12个月）相应前一年的对比年月
export function getDxUnionAll (indexId, date) {
  let dayArray = 'SELECT to_char(ADD_MONTHS(TO_DATE(\'before\', \'yyyyMM\'), ROWNUM - 1),\'yyyyMM\')  as MONTHID,  NULL as SHORT_RISK_RATE,  NULL AS SHORT_RISK_RATE_LAST     FROM DUAL   CONNECT BY ROWNUM <= months_between(to_date(\'after\', \'yyyyMM\'), to_date(\'before\', \'yyyyMM\')) + 1'
  let cur = 24 * 60 * 60 * 1000
  let year = ''
  let month = ''
  // 短险综合成本率：不包括当前月在内的12个月的年月（格式：eg:201908）的值
  if (indexId === 'A0104-1004') {
    year = date.getFullYear()
    if (year === 2019) {
      month = date.getMonth()
      dayArray = dayArray.replace('before', String(year) + String(changeDay(1))).replace('after', String(year) + String(changeDay(month))).replace('before', String(year) + String(changeDay(1)))
    } else {
      month = date.getMonth()
      if (month === 0) {
        dayArray = dayArray.replace('after', String(year - 1) + String(changeDay(12)))
      } else {
        dayArray = dayArray.replace('after', String(year) + String(changeDay(month)))
      }
      for (var p = 0; p < 12; p++) {
        let monthFirstDay1 = new Date(year, month, 1)
        let monthFinishDay1 = new Date(monthFirstDay1.getTime() - cur)
        year = monthFinishDay1.getFullYear()
        month = monthFinishDay1.getMonth()
      }
      dayArray = dayArray.replace('before', String(year) + String(changeDay(month + 1))).replace('before', String(year) + String(changeDay(month + 1)))
    }
  }
  return dayArray
}

export function changeDay (val) {
  val = val < 10 ? '0' + val : val
  return val
}

export var ifrSrc = {
  smartbiUrl: getSmartbiUrl() + '/vision/openresource.jsp?scroll=false',
  // 为表格时,需要表格数据上下可以滑动
  smartbiUrlTable: getSmartbiUrl() + '/vision/openresource.jsp?',
  // smartbi报表的resid
  columnResid: 'Iff808081018b405940597cdf018b4bd070cc53bf',

  lineResid: 'Iff808081018b405940597cdf018b4bd0515353b5',

  tableResid: 'Iff808081018b405940597cdf018b4bd0b19253ca',

  solidPieResid: 'Iff808081018b405940597cdf018b4bd1098c53dc',

  termSolidPieResid: 'Iff808081016f9b8c9b8cfa01016fb5424fa3674a',

  hollowPieResid: 'Iff808081018b405940597cdf018b4bd0e4a653d3',

  bankPieResid: 'Iff808081016f9b8c9b8cfa01016fb5426f7a6758',

  dxColumnResid: 'Iff808081016f9b8c9b8cfa01016fb54198316727',

  dxLineResid: 'Iff80808101710e560e566ea701712d4c9b8a6188',

  dxTableResid: 'Iff808081016f9b8c9b8cfa01016fb541fefb673b',
  // 产品-渠道分析-环图
  productHollowPieResid: 'Iff8080810178673067307868017881b0d3db1acd',
  // 产品-结构分析-饼图
  productSolidPieResid: 'Iff8080810178673067307868017881b11ad91afa',
  // 价值体系-表格
  vbmTableResid: 'Iff808081017ed34fd34f11bf017fb093598e2df0',
  // 价值体系-折线图
  vbmLineResid: 'Iff808081017ed34fd34f11bf017fbead83fb2242',
  // 价值体系-柱状图
  vbmColumnResid: 'Iff808081017ed34fd34f11bf017fbeaddcae224c',
  // 财务创费-表格
  financeTableResid: 'Iff8080810185525f525fef4d0186c02ebd6410b5',
  // 财务创费-柱图
  financeColumnResid: 'Iff8080810185525f525fef4d0186c02d7cf010a5',
  // 财务创费-折线图
  financeLineResid: 'Iff8080810185525f525fef4d0186c0244c2e0fb6',
  // 业绩看板结构分析饼图无趸交
  yejiBankResid: 'Iff808081018b405940597cdf018c90b5f440202d'
}

// 期末规模人力    A0201-1002
// 合格人力    A0202-1013
// 个险模块：期末规模人力、合格人力
// 银代模块：期末规模人力
export var renliIndex = ['A0201-1002', 'A0202-1013']
export var qimoIndex = ['A0201-1002']
// 短险综合成本率
export var dxzhcbl = ['A0104-1004']
// 考核口径
export var khkj = ['A0101-1007', 'A0104-1003']

// 考核口径率值类部分指标时间传当前年的1月到当前月(eg:201911)：14个月件数继续率、26个月件数继续率、14个月保费继续率、26个月保费继续率
export var AssementRateMonth = ['A0401-1023', 'A0401-1024', 'A0401-1008', 'A0401-1009']



// WEBPACK FOOTER //
// ./src/utils/smartbi/dataComponent.js